import type { ReactEventHandler } from 'react';

// TODO: подумать. У нас связка атомы-утилиты-сервисы получается
// Она формально нелегальная с точки зрения атомика, но вроде не вот прям безумная, т.к. логгер это просто console.log
// eslint-disable-next-line boundaries/element-types
import ClientLogger from '~logger/client';
// eslint-disable-next-line boundaries/element-types
import { LoggerMessages, LoggerServices } from '~logger/constants';

export const onImageLoadError: ReactEventHandler<HTMLImageElement> = (e) => {
	return ClientLogger.info(
		LoggerServices.ImageLoader,
		LoggerMessages.ImageLoadingError,
		// @ts-ignore
		{ requestUrl: e.target?.currentSrc }
	);
};
